export default {
  headerStatus: state => state.headerStatus,
  userInfo: state => state.userInfo,
  userPermissions: state => state.userPermissions,
  permissionMap: state => state.permissionMap,
  // 检查是否有某个权限
  hasPermission: state => (permission) => {
    // 超级管理员拥有所有权限
    if (state.userInfo && state.userInfo.superman === 1) {
      return true;
    }
    return !!state.permissionMap[permission];
  },
  // 检查是否有任一权限
  hasAnyPermission: state => (permissions) => {
    // 超级管理员拥有所有权限
    if (state.userInfo && state.userInfo.superman === 1) {
      return true;
    }
    if (!permissions || !permissions.length) return false;
    return permissions.some(p => state.permissionMap[p]);
  },
  // 检查是否有所有权限
  hasAllPermissions: state => (permissions) => {
    // 超级管理员拥有所有权限
    if (state.userInfo && state.userInfo.superman === 1) {
      return true;
    }
    if (!permissions || !permissions.length) return false;
    return permissions.every(p => state.permissionMap[p]);
  }
}


// WEBPACK FOOTER //
// ./src/store/getters.js